import axios from 'axios';
import React, { useImperativeHandle, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { CREATE_CUSTOM_FIELD } from '../../../constants/custom-field-endpoint';
import { Form, Offcanvas } from 'react-bootstrap';
import FieldError from '../../../shared/fields-errors/field-error';
import "./custom-fields.scss"

const AddCustomFieldCanvas = React.forwardRef(({refreshData, entity_type, entity_id}, ref) => {

    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const { register, control, handleSubmit, setValue, watch, trigger, unregister, reset, formState: { errors, isValid } } = useForm({
        defaultValues: {
            "field_label": "",
            "field_description": "",
            "field_type": "text",
            "entity_type":entity_type,
            "field_options":{},
            "field_is_required": false
        }
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'field_options'
    });

    const currentFields = watch();

    const handleShow = (item) => {
        if (item?.id) {
            setIsEdit(true);
            reset({
                "id": item?.id,
                "field_label": item?.field_label,
                "field_description": item?.field_description,
                "field_type": item?.field_type,
                "entity_type":item?.entity_type,
                "field_options": item?.field_options,
                "field_is_required": item?.field_is_required
            })
        } else {
            setIsEdit(false);
            reset({
                "field_label": "",
                "field_description": "",
                "field_type": "text",
                "entity_type":entity_type,
                "field_options": [],
                "field_is_required": item?.field_is_required
            });
        }

        setErrorMessage("");
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    useImperativeHandle(ref, () => {
        return {
            handleShow: handleShow
        };
    });

    const changeType = (type) => {
        setValue('field_type', type);
        if (type === 'dropdown') {
            register("field_options", {
                required: {
                    value: true,
                    message: 'Options is required for dropdown'
                }
            })
        } else {
            unregister("field_options")
        }
    }

    const submitForm = (values) => {
        setErrorMessage("");
        setLoader(true);
        axios.post(`${CREATE_CUSTOM_FIELD}${entity_id ? `?entity_id=${entity_id}` : ''}`, values)
            .then((res) => {
                setLoader(false);
                if (res?.data?.status) {
                    refreshData();
                    handleClose();
                } else {
                    setErrorMessage(res?.data?.message);
                }
            }).catch((error) => {
                setErrorMessage("Failed to save custom field.");
                setLoader(false);
            })
    }


    return (
        <>
            <Offcanvas backdrop="static" show={show} onHide={handleClose} placement='end'>
            <Offcanvas.Header className='pt-3 pb-3'>
                <Offcanvas.Title>{isEdit ? 'Update Field' : 'Add New Field'}</Offcanvas.Title>
            </Offcanvas.Header>
            < hr className='m-0' />
            <Offcanvas.Body>
                <div className='row position-relative' style={{
                    height: '300px'
                }}>
                    <div className='col-12'>
                        <div className='row' style={{
                            borderBottom:'1px solid lightgrey'
                        }}>
                            {
                                !isEdit ? 
                                <div className='col-4 custom-fields-sidebar'>
                                <ul className='p-0'>
                                    <li className={currentFields?.field_type === 'text' ? 'active' : ''} onClick={() => changeType('text')}><i className="fa-solid fa-font"></i> Text</li>
                                    <li className={currentFields?.field_type === 'number' ? 'active' : ''} onClick={() => changeType('number')}><i className="fa-solid fa-hashtag"></i> Number</li>
                                    <li className={currentFields?.field_type === 'date' ? 'active' : ''} onClick={() => changeType('date')}><i className="fa-solid fa-calendar-days"></i> Date</li>
                                    <li className={currentFields?.field_type === 'checkbox' ? 'active' : ''} onClick={() => changeType('checkbox')}><i className="fa-solid fa-square-check"></i> Checkbox</li>
                                    <li className={currentFields?.field_type === 'dropdown' ? 'active' : ''} onClick={() => changeType('dropdown')}><i className="fa-solid fa-plus-minus"></i> Option</li>
                                </ul>
                            </div> : ''
                            }
                            <div className={isEdit ? 'col-12' : 'col-8'}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Custom Field Label</Form.Label>
                                    <Form.Control
                                        {...register("field_label", {
                                            required: {
                                                value: true,
                                                message: 'Field is required'
                                            }
                                        })}
                                        type="text"
                                        placeholder="Enter custom field label" />
                                    {errors?.field_label ? <FieldError message={errors?.field_label?.message} /> : ''}
                                </Form.Group>
                                <Form.Group className="mb-3" >
                                    <Form.Label className='mb-0'>Optional Description</Form.Label>
                                    <p className='text-black f-12-small'>Displays below the field</p>
                                    <Form.Control
                                        {...register("field_description")}
                                        type="text"
                                        placeholder="Enter custom field description" />
                                </Form.Group>
                                        

                                {/* for dropdown */}
                                {
                                    currentFields?.field_type === 'dropdown' ?
                                        <div className='mt-3'>
                                            <h6>Dropdown Options</h6>
                                            <hr className='m-2' />
                                            <Form.Group className="mb-3" >
                                                <Form.Label>Add Item</Form.Label>
                                                <Form.Control
                                                    onKeyUp={(event) => {
                                                        if ((event.key === 'Enter' || event.keyCode === 13) && event.target.value) {
                                                            const index = fields?.findIndex(it => it.value?.toLowerCase() === event.target.value?.toLowerCase());
                                                            if (index === -1) {
                                                                append({ value: event.target.value });
                                                                event.target.value = "";
                                                                event.preventDefault()
                                                            } else {
                                                                alert("Duplicate value.")
                                                            }

                                                        }
                                                    }}
                                                    type="text"
                                                    placeholder="Enter option" />
                                                {errors?.field_options ? <FieldError message={'Field options is required for dropdown'} /> : ''}
                                            </Form.Group>
                                            <ul className='custom-field-dropdown'>
                                                {
                                                    fields?.map((item, index) => {
                                                        return <li key={`option_${index}`} className='cursor-pointer d-flex justify-content-between align-items-center'>
                                                            {item.value} <i onClick={() => {
                                                                remove(index)
                                                            }} className="text-danger fa-solid fa-trash-can"></i>
                                                        </li>
                                                    })
                                                }
                                            </ul>
                                        </div> : ''
                                }

                                    {
                                        currentFields?.field_type !== 'checkbox' ?
                                            <label className="mb-3 form-control-label d-flex align-items-center">
                                                <input {...register('field_is_required')} className="me-1" type="checkbox" />
                                                Required</label> : ''
                                    }
                            </div>
                            {errorMessage ? <FieldError message={errorMessage} /> : ''}
                        </div>
                    </div>
                </div>
                <div style={{
                    backgroundColor: 'rgb(250 250 250)',
                    borderTop: '1px solid rgb(228 228 231)',
                }} className='position-absolute bottom-0 p-3 start-0 w-100 d-flex justify-content-between align-items-center'>
                    <button
                        disabled={loader}
                        onClick={handleClose} type='button' className='mb-0 me-2 btn btn-outline-secondary'>Cancel</button>
                    <button
                        disabled={loader}
                        onClick={async () => {
                        const valid = await trigger();
                        if (valid) {
                            submitForm(currentFields)
                        }
                    }}
                         type='button'
                        className={`${loader ? 'position-relative button--loading' : ''} mb-0 btn btn-outline-primary`}
                    >{isEdit ? 'Update' : 'Save'}</button>

                </div>
            </Offcanvas.Body>
        </Offcanvas>
        </>
        
    );
});

export default AddCustomFieldCanvas;